import { createSelector } from 'reselect'
import { getPlanById } from 'utils/plan';
import { getTeamPlanId, getTeamIsOnTrial } from 'utils/billing';

const ALLOWED_PAST_DUE_TIME = 1000 * 60 * 60 * 24 * 7; // 7 days

const getRemainingTrial = (team, date = Date.now()) => {
    if (!team || !team.subscription_status || team.subscription_status !== 'trialing') {
        return null;
    }

    return Math.max(0, Math.floor((new Date(team.trial_end) - date) / 86400000));
}
export const makeGetRemainingTrial = () => createSelector(getRemainingTrial, remainingTrial => remainingTrial);

const getIsOnTrial = team => getTeamIsOnTrial(team);
export const makeGetIsOnTrial = () => createSelector(getIsOnTrial, isOnTrial => isOnTrial);

const getSubscriptionIsExpired = (team, hard) => {
    if (!team || !team.subscription_status) {
        return null;
    }

    const plan = team.plan && getPlanById(team.plan);

    if (!plan || plan.price?.free || plan.price?.lifetime) {
        return false;
    }

    return (
        team.subscription_status === 'expired' ||
        team.subscription_status === 'incomplete' ||
        team.subscription_status === 'incomplete_expired' ||
        team.subscription_status === 'canceled' ||
        (hard && team.subscription_status === 'past_due') ||
        (hard && team.subscription_status === 'unpaid') ||
        (
            team.subscription_status === 'past_due' && (
                !team.source_id ||
                (
                    team.current_period_start &&
                    new Date() - new Date(team.current_period_start) > ALLOWED_PAST_DUE_TIME
                )
            )
        )
    );
}
export const makeGetSubscriptionIsExpired = () => createSelector(getSubscriptionIsExpired, isExpired => isExpired);

const getIsOnFreePlan = team => {
    if (!team) {
        return false;
    }

    if (getPlanById(team.plan)?.price?.free) {
        return true;
    }

    return false;
}
export const makeGetIsOnFreePlan = () => createSelector(getIsOnFreePlan, isExpired => isExpired);

const getSubscriptionIsPastDue = team => {
    if (!team || !team.subscription_status) {
        return null;
    }

    const plan = team.plan && getPlanById(team.plan);

    if (!plan || plan.price?.free || plan.price?.lifetime) {
        return false;
    }

    return (
        team.subscription_status === 'past_due' &&
        team.source_id &&
        team.current_period_start &&
        new Date() - new Date(team.current_period_start) < ALLOWED_PAST_DUE_TIME
    );
}
export const makeGetSubscriptionIsPastDue = () => createSelector(getSubscriptionIsPastDue, isPastDue => isPastDue);

const getCurrentPlanId = team => getTeamPlanId(team);
export const makeGetCurrentPlanId = () => createSelector(getCurrentPlanId, planId => planId);
